import Kibo from './kibo'

export default { Kibo }



// WEBPACK FOOTER //
// ./src/vendor/index.js